import { useTranslation } from 'react-i18next';

const NyseStepTwo = () => {
  const { t } = useTranslation(['contractModal']);

  return (
    <div className={'contracts-steps-body'}>
      <h2 style={{ textTransform: 'uppercase' }}>
        {t(
          'contractModal:nyse_modal.section_1_terms_and_conditions_of_general_applicability',
        )}
      </h2>
      <ol>
        <li>{t('contractModal:nyse_modal.market_data_definition')}</li>
        <li>{t('contractModal:nyse_modal.proprietary_nature_of_data')}</li>
        <li>{t('contractModal:nyse_modal.enforcement')}</li>
      </ol>
    </div>
  );
};

export default NyseStepTwo;
